import { useEffect, useState } from "react";
import { Download, FileText } from "lucide-react";
import { api } from "../../lib/api";

export default function Reportes() {
    const [schools, setSchools] = useState([]);
    const [downloadingPdf, setDownloadingPdf] = useState(false);
    useEffect(() => {
        api.get("/ejecutivo/schools").then((r) => setSchools(r.data || []));
    }, []);

    function downloadCSV() {
        const rows = [["Colegio", "País", "Estudiantes activos", "Estado"]];
        schools.forEach((s) =>
            rows.push([s.name, s.country, String(s.active_students), s.active ? "Activo" : "Inactivo"]),
        );
        const csv = rows.map((r) => r.join(",")).join("\n");
        const blob = new Blob([csv], { type: "text/csv" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "reporte_global.csv";
        a.click();
        URL.revokeObjectURL(url);
    }

    async function downloadPDF() {
        setDownloadingPdf(true);
        try {
            const resp = await api.get("/reports/ejecutivo/pdf", { responseType: "blob" });
            const url = URL.createObjectURL(resp.data);
            const a = document.createElement("a");
            a.href = url;
            a.download = "reporte_global_eduperu.pdf";
            a.click();
            URL.revokeObjectURL(url);
        } finally {
            setDownloadingPdf(false);
        }
    }

    return (
        <div className="p-6 md:p-10 fade-in" data-testid="ejecutivo-reportes-page">
            <h1 className="text-3xl font-semibold mb-1">Reportes Globales</h1>
            <p className="text-edu-body mb-6">Descarga reportes consolidados.</p>
            <div className="flex flex-wrap gap-3">
                <button
                    onClick={downloadPDF}
                    disabled={downloadingPdf}
                    className="edu-btn-primary px-5 py-2.5 text-sm inline-flex items-center gap-2 disabled:opacity-50"
                    data-testid="download-pdf"
                >
                    <FileText size={14} /> {downloadingPdf ? "Generando…" : "Descargar reporte global PDF"}
                </button>
                <button
                    onClick={downloadCSV}
                    className="px-5 py-2.5 text-sm rounded-xl border border-edu inline-flex items-center gap-2 hover:bg-gray-50"
                    data-testid="download-csv"
                >
                    <Download size={14} /> CSV de colegios
                </button>
            </div>
        </div>
    );
}
